var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 184,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "play_large_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 184,
    height: 184
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h184v184H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#play_large_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.656 120.752l37.376-23.959c1.788-1.15 2.683-2.747 2.683-4.791 0-2.045-.895-3.642-2.683-4.792L81.656 63.252c-1.916-1.278-3.865-1.374-5.845-.288-1.98 1.086-2.971 2.78-2.971 5.08v47.916c0 2.3.99 3.993 2.97 5.079 1.981 1.086 3.93.99 5.846-.287zm10.35 47.916c-10.605 0-20.572-2.012-29.9-6.037-9.327-4.025-17.441-9.488-24.341-16.388-6.9-6.9-12.363-15.014-16.388-24.341-4.025-9.328-6.037-19.295-6.037-29.9 0-10.606 2.012-20.573 6.037-29.9 4.025-9.328 9.488-17.442 16.388-24.342 6.9-6.9 15.014-12.362 24.341-16.387 9.328-4.026 19.295-6.038 29.9-6.038 10.606 0 20.573 2.012 29.901 6.037 9.327 4.026 17.441 9.488 24.341 16.388 6.9 6.9 12.363 15.014 16.388 24.342 4.025 9.327 6.037 19.294 6.037 29.9 0 10.605-2.012 20.572-6.037 29.9-4.025 9.327-9.488 17.441-16.388 24.341-6.9 6.9-15.014 12.363-24.341 16.388-9.328 4.025-19.295 6.037-29.9 6.037zm0-15.333c17.123 0 31.626-5.942 43.509-17.825s17.825-26.386 17.825-43.508c0-17.123-5.942-31.625-17.825-43.509-11.883-11.883-26.386-17.825-43.508-17.825-17.123 0-31.626 5.942-43.509 17.825C36.615 60.377 30.673 74.88 30.673 92.002c0 17.122 5.942 31.625 17.825 43.508 11.884 11.883 26.386 17.825 43.509 17.825z",
    fill: "#fff"
  }))));
}
export default SvgPlayLarge;